import { render, staticRenderFns } from "./BaseTLSpinner.vue?vue&type=template&id=f48e7434&"
import script from "./BaseTLSpinner.vue?vue&type=script&lang=ts&"
export * from "./BaseTLSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports